import React from 'react';
import { ErrorMessage, useField } from 'formik';
import './index.scss';
import { uid } from 'utils';

interface IProps {
  name: string;
  id?: string;
  label: string;
  placeholder?: string;
  inputWrapperClass?: string;
  inputClass?: string;
  required?: boolean;
  options: Array<{ value: string; label: string }>;
  onChange?: (option: { value: string; label: string } | null) => void;
}

export const Select = ({
  name,
  id,
  label,
  placeholder = 'Select an option',
  inputWrapperClass,
  inputClass,
  required,
  options,
  onChange
}: IProps) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    helpers.setValue(selectedValue);

    if (onChange) {
      const selectedOption = options.find(
        (option) => option.value === selectedValue
      );
      onChange(selectedOption || null);
    }
  };

  return (
    <div className={`input-select-wrapper ${inputWrapperClass}`}>
      <label htmlFor={id || name} className="input-label">
        {label}
        {required ? <span className="input-required">*</span> : null}
      </label>
      <select
        className={`input-box ${inputClass} ${
          meta.touched && meta.error ? 'input-error' : ''
        }`}
        value={field.value || ''}
        onChange={handleChange}
        id={id || name}
        name={name}
      >
        <option value="" label={placeholder} />
        {options.map((option) => (
          <option
            key={option.value || uid()}
            value={option.value}
            label={option.label}
          >
            {option.label}
          </option>
        ))}
      </select>
      <ErrorMessage name={name} component="div" className="error" />
    </div>
  );
};
